import React, { useMemo } from "react";
import { ChapterTree } from "../../../../../../service/CourseDetail/chapter";
import { Tooltip, Tree } from "antd";
import Style from "./index.module.scss";
import { SourceItem } from "../../../../service";
import ListItemV2 from "../../../../../../components/CourseComponents/Resource/ListItem";

const { TreeNode } = Tree;

interface Props {
    show: "window" | "page";
    data?: ChapterTree[];
    rowSelection: any;
}
const Index = ({ data, rowSelection, show }: Props) => {
    const nodeMap = useMemo(() => {
        return new Map<string, ChapterTree | SourceItem>();
    }, []);

    function renderTreeNodes(data: ChapterTree[]) {
        return data.map(item => {
            const nodeKey = `NODE_${item.id}`;
            item.key = nodeKey;
            nodeMap.set(nodeKey, item);

            const nodes = (
                <div className={Style.title}>
                    {item?.chapterName.length > 15 ? (
                        <Tooltip placement="top" title={item?.chapterName}>
                            <b>{item?.chapterName}</b>
                        </Tooltip>
                    ) : (
                        <b>{item?.chapterName}</b>
                    )}
                </div>
            );
            const fileNodes = item.dcCoursewareSourceList.map(source => {
                const fileKey = `${source.id}`;
                source.key = fileKey;
                nodeMap.set(fileKey, source);
                return (
                    <TreeNode
                        key={source.key}
                        title={
                            <ListItemV2
                                model="res"
                                source={source}
                                className={Style.fileItem}
                            />
                        }
                    />
                );
            });
            if (item.children.length > 0) {
                return (
                    <TreeNode title={nodes} key={item.key} dataRef={item}>
                        {renderTreeNodes(item.children).concat(fileNodes)}
                    </TreeNode>
                );
            } else {
                return (
                    <React.Fragment key={item.id.toString()}>
                        <TreeNode key={item.key} title={nodes}>
                            {fileNodes}
                        </TreeNode>
                    </React.Fragment>
                );
            }
        });
    }
    const yHeight = useMemo(() => {
        switch (show) {
            case "page":
                return "calc(100vh - 238px)";
            case "window":
                return "calc(100vh - 310px)";
            default:
                return "100%";
        }
    }, [show]);
    return (
        <div className={Style.root} style={{ height: yHeight }}>
            {data && data.length > 0 && (
                <Tree
                    defaultExpandAll
                    selectable={false}
                    blockNode
                    checkedKeys={rowSelection.selected}
                    onCheck={(checkedKeys, e) => {
                        rowSelection.setSelected(checkedKeys as string[]);
                    }}
                    checkable={show === "window"}>
                    {renderTreeNodes(data)}
                </Tree>
            )}
        </div>
    );
};

export default Index;
